import React from 'react'
// import styled from 'styled-components'
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import 'antd/dist/antd.css';

const ModalComponent = (props) => {
  return (
    <div>
      <Modal footer={null} centered closable={false} visible = {props.visible}>
        {props.children}
      </Modal>
    </div>
  )
}

ModalComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default ModalComponent